import React from 'react'
import { BrowserRouter as Router } from 'react-router-dom'
import { ApolloProvider } from '@apollo/client'
import { I18nextProvider } from 'react-i18next'

import apolloClient from '@/apollo'
import Routes from '@/navigation/routes'
import 'react-toastify/dist/ReactToastify.css'
import i18n from './i18n'
import { AppContextProvider } from './AppContext'
import './App.scss'
import { createTheme, ThemeProvider } from '@mui/material'

const theme = createTheme({
  direction: 'rtl',
  palette: {
    primary: {
      main: '#4094f7',
    },
    // You can add other colors here if needed.
  },
  // You can add other theme settings here if needed.
})

const App: React.FC = () => (
  <ApolloProvider client={apolloClient}>
    <ThemeProvider theme={theme}>
      <Router>
        <AppContextProvider>
          <I18nextProvider i18n={i18n}>
            <Routes />
          </I18nextProvider>
        </AppContextProvider>
      </Router>
    </ThemeProvider>
  </ApolloProvider>
)

export default App
